// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module__button___1YmQo","disabled_button":"Button-module__disabled_button___2dZT1","secondary_button":"Button-module__secondary_button___34fLF"};